import { useMemo } from 'react';

import { useSelectedStore } from '@web/app/shared';

import { useFetchProductsByProjectId } from '@codes/product';

export const useProductService = () => {
    const { project } = useSelectedStore();

    const myProductsQueryResult = useFetchProductsByProjectId(project?.id || '');

    const myProducts = useMemo(() => {
        const products =
            !!myProductsQueryResult.data && !!myProductsQueryResult.data.data ? myProductsQueryResult.data.data : [];
        // Filter out child products (id contains '@')
        return products.filter(product => !product.id?.includes('@'));
    }, [myProductsQueryResult.data]);

    const areMyProductsEmpty =
        !!myProductsQueryResult.data && !!myProductsQueryResult.data.data && myProductsQueryResult.data.total === 0;

    return { myProductsQueryResult, myProducts, areMyProductsEmpty };
};
